import { Link, LinkProps } from 'react-router-dom';
import './infographic.css';
import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { HomePageYageoInfographicSection } from '../../../graphql/pimcore/modules/siteContent/types/HomePageContent';

interface InfographicProps {
    cmsContent: HomePageYageoInfographicSection;
}

export default function Infographic({ cmsContent }: InfographicProps) {
    const { title, image, learnMoreLink } = cmsContent;
    const imageUrl = image.imageUrl;

    return (
        <div className="infographic-styling">
            <div className="glance-title">{title.content}</div>
            <div className="flex-row-styling">
                <img style={{ width: '110%' }} src={imageUrl} alt="Infographic" />
            </div>
            <div className="flex-col align-right">
                <LearnMoreButton
                    component={Link}
                    to={learnMoreLink.linkRoute}
                    className="product-button"
                >
                    {learnMoreLink.linkText}
                </LearnMoreButton>
            </div>
        </div>
    );
}

export const LearnMoreButton = styled(Button)<ButtonProps & LinkProps>({
    fontFamily: 'Poppins',
    fontSize: '1.3rem',
    lineHeight: '0.5rem',
    color: '#ffffff',
    textTransform: 'none',
    backgroundColor: '#e5673e',
    padding: '0.75rem 0 0.5rem',
    borderRadius: '0.31rem',
    overflow: 'hidden',
    width: '11.63rem',
    height: '2.75rem',
    '&:hover': {
        backgroundImage: 'linear-gradient(#ee9769, #e5673e)',
    },
});
